module.exports = __webpack_public_path__ + "img/danwei.53f1c064.png";